import AuthService from '@services/auth.service';

const actions = {
    ['REGISTER'](ctx, data) {
        return AuthService.register(data);
    },
    ['LOGIN'](ctx, data) {
        return AuthService.login(data);
    },
    ['LOGOUT'](ctx) {
        AuthService.logout().then(() => {
            location.reload();
        });
    }
};

const getters = {
    authCheck: state => AuthService.isAuthorized,
    envUrl: state => process.env.NODE_ENV !== 'development' ? process.env.PROD_URL : process.env.DEV_URL
};

export default {
    actions,
    getters
};
